import React from 'react';
import { useSelector } from 'react-redux';

export default function useErrorSelector() {
  const ErrorStatus = useSelector((state) => state.error.errorData);
  const SuccessStatus = useSelector((state) => state.error.successData);
  return { ErrorStatus, SuccessStatus };
}
